import {
  defaultChainId,
  wethTokenEthereumUniswapV2PairAddress as ethereumAddress,
  wethTokenGoerliUniswapV2PairAddress as goerliAddress,
} from '../configs';
import { UniswapV2PairAbi as abi } from '../abis';



export default function getWethTokenUniswapV2PairContractData() {
  let address = null;
  switch (defaultChainId) {
    case 1: address = ethereumAddress; break;
    case 5: address = goerliAddress; break;
    default: break;
  }

  return {
    address,
    abi,
    chainId: defaultChainId,
  };
}
